import Cookies from 'js-cookie';

import { useSplitTestBranch } from '../api/lendingApi/lendingApiQueries';
import { ISOLATED_SPLIT_TESTS } from '../constants';
import { useLocale } from './useLocale';

export const REPAYMENT_REDUCTION_PREVIEW_COOKIE =
  'iw-de-repayment-reduction-preview';

export function useIsInDERepaymentReductionTest() {
  const { isDE } = useLocale();
  const isPreviewEnabled =
    Cookies.get(REPAYMENT_REDUCTION_PREVIEW_COOKIE) === 'true';

  const { splitTestBranch, isLoading } = useSplitTestBranch(
    ISOLATED_SPLIT_TESTS.DE_REPAYMENT_REDUCTION_TEST,
    { enabled: isDE && isPreviewEnabled, cookieOverride: true },
  );

  return {
    isLoading,
    isIncludedInRepaymentReductionTest:
      isPreviewEnabled && splitTestBranch === 'INCLUDE',
  };
}
